import { track as analyticsTrack } from '@fff-web/fff-analytics';
import { getUUID } from '..';

const track = (name: string, experimentData: any) => {
  analyticsTrack({
    trackName: name,
    properties: experimentData,
    options: {
      Optimizely: {
        userId: getUUID(),
      },
    },
  });
};

export default track;
